import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import * as apicall from "../../components/Apicall";
import Loader from "../../components/Loader/Loader";

function EachRowCell({ item, currentEdit, refreshPage }) {
  const [name, setName] = useState(item?.name);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  async function editNameFunction() {
    try {
      let data = {
        id: item?.id,
        name: name,
      };
      let api = "editService";
      if (currentEdit === "Profile") {
        api = "editPartner";
      }

      setLoading(true);
      const response = await apicall.post(data, api);
      setEdit(false);
      setLoading(false);
      refreshPage();
    } catch (e) {
      console.log("err---", e);
    }
  }

  return (
    <div className="px-4 py-2 d-flex justify-content-between border bgWhite">
      {!edit ? (
        <div>{item?.name}</div>
      ) : (
        <div className="w-100">
          <input
            onKeyDown={(e) => e.key === "Enter" && editNameFunction()}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-50"
            autoFocus
          />
          {loading ? (
            <Loader style={{ width: 40, height: 20 }} />
          ) : (
            <FaArrowRight onClick={editNameFunction} className="rightClick" />
          )}
        </div>
      )}
      <MdModeEdit className="cursor-pointer" onClick={() => setEdit(!edit)} />
    </div>
  );
}

export default EachRowCell;
